import { ResultStatus } from '../types';
import { getEntry } from './read-model-reducer';
import { useSelector } from 'react-redux';
import { getSelectorState } from './initial-state-manager';

function useReduxReadModelSelector(query) {
  var actualSelector = typeof query === 'string' ? query : {
    query: query
  };
  return useSelector(function (state) {
    return getEntry(state.readModels, actualSelector, {
      status: ResultStatus.Initial,
      data: getSelectorState(actualSelector)
    });
  });
}

export { useReduxReadModelSelector };
//# sourceMappingURL=use-redux-read-model-selector.js.map